export default __webpack_public_path__ + "static/register_account-b0fc272c7d1fa1ad7103a41bbf44e277.webp";